import { Link } from "react-router-dom";
import { formatBRL } from "../lib/currency";

export interface BookCardData {
  slug: string;
  title: string;
  subtitle?: string | null;
  coverUrl: string | null;
  isFree: boolean;
  priceCents: number | null;
}

export function BookCard({ book }: { book: BookCardData }) {
  return (
    <Link to={`/livro/${book.slug}`} className="card book-card">
      <div className="book-card__cover">
        {book.coverUrl ? (
          <img src={book.coverUrl} alt={`Capa de ${book.title}`} />
        ) : (
          <span className="book-card__cover-fallback" aria-hidden="true">
            {book.title.charAt(0)}
          </span>
        )}
      </div>
      <strong className="book-card__title">{book.title}</strong>
      {book.subtitle && (
        <span className="text-muted" style={{ fontSize: "var(--text-sm)" }}>
          {book.subtitle}
        </span>
      )}
      <div className="book-card__price">{book.isFree ? "Gratuito" : book.priceCents != null ? formatBRL(book.priceCents) : "—"}</div>
    </Link>
  );
}
